import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { BaseService } from "app/shared/_utils/services/base-service";
import { ResponsePageable } from "app/shared/_utils/services/responsePageable";
import { Observable } from '../../../../node_modules/rxjs';
import { InterfaceAirhsp } from "../model/interface-airhsp";
import { Vars } from "../model/vars";
import * as FileSaver from 'file-saver';
import { catchError, tap, map } from 'rxjs/operators';

@Injectable()
export class InterfaceAirhspService extends BaseService {
    public uri = '/api/airhspInterface/';

    constructor(injector: Injector) {
        super(injector);
    }

    searchInterfaceAirhsp(fiscalYear: any, executingUnit: any, month: any,
        employeeType: any, type: any,
        object: Vars): Observable<ResponsePageable<InterfaceAirhsp>> {
        const params = new HttpParams()
            .set('fiscalYearId', fiscalYear)
            .set('euId', executingUnit)
            .set('monthId', month)
            .set('employeeTypeId', employeeType)
            .set('type', type)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}searchAirhspInterface`;
        return this.httpClient.post<ResponsePageable<InterfaceAirhsp>>(url, object, { params },)
            .pipe(
                tap(response => {
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }

     
    downloadExcel(fiscalYear: any, executingUnit: any, month: any,
        employeeType: any, type: any,
        object: Vars): Observable<Blob> {
        let ruta = this.rutaServidor + this.uri   +  'interfaceAirhspXLS';
        //console.log("ruta : "  + ruta);
        const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
            .set('euId', executingUnit)
            .set('monthId', month)
            .set('employeeTypeId', employeeType)
            .set('type', type)
         this.spinnerService.showAll(); 
        return this.httpClient.post(ruta, object, {params, responseType: 'blob' })
            .pipe( 
                map(res =>  {   
                    this.spinnerService.hideAll();
                    let bean = new Blob([res],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                    FileSaver.saveAs(bean, 'interfaceAirhsp.xls');
                    return bean;
                }),
                catchError((err, caught) => { 
                    //console.log("catchError : "  + catchError);
                    this.spinnerService.hideAll(); 
                    this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                    return new Observable<Blob>();
                }) 
                 
            ); 
 
    }

}


// WEBPACK FOOTER //
// ./src/app/core/services/interface-airhsp.service.ts